var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.active)?_c('footer',{class:[{'offline' : !_vm.isOnline},{'tosync' : (_vm.isOnline && _vm.$root.$children[0].toSyncCardSends)}, _vm.classes, _vm.color]},[_vm._t("default")],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }